// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Gdhht","selectedFile":"styles_selectedFile__+GF5G","selectedFileName":"styles_selectedFileName__1xkZc","addLogoBtn":"styles_addLogoBtn__szZip"};